
export const servicesData = [
  {
    id: 1,
    icon: "https://cdn4.iconfinder.com/data/icons/technology-83/1000/app_frontend_end_front_front-end_front_end_development-512.png",
    name: "Responsive Web Development Using Html,Css and Javascript",
    price: 49.99,
    description: "Discover the art of Responsive Web Development through our HTML, CSS, and JavaScript expertise. We craft engaging websites that adapt seamlessly to various devices, ensuring a captivating user experience. Our team's meticulous use of HTML forms a robust foundation, while CSS enhances aesthetics and user-friendliness. With JavaScript, we infuse interactivity and real-time elements, resulting in dynamic and engaging websites. Elevate your online presence with our services, where innovation and responsiveness converge for a truly remarkable web experience."
  },
 
  {
    id: 2,
    icon:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/512px-React-icon.svg.png?20220125121207",
    name: "Responsive Web Development Using React.js",
    price: 79.99,
    description: "Welcome to our Responsive Web Development services, where we harness the power of React.js to create dynamic and user-centric websites. Our expert team of developers excels at crafting seamless, responsive interfaces that adapt flawlessly to various devices and screen sizes. With a focus on user experience and modern design principles, we ensure that your website engages visitors and drives meaningful interactions. Leveraging the flexibility of React.js, we build highly interactive and efficient web applications that bring your ideas to life. Join us in transforming your online presence with cutting-edge technology and responsive design expertise.",
  },
  {
    id: 3,
    icon:
      "https://www.micazook.com/img/ico/ico_UIUXDesign.png",
    name: "UIUXDesign  using Canva and Figma",
    price: 49.99,
    description: "Welcome to our UI/UX Design services, where we transform ideas into captivating digital experiences. Our skilled team leverages the power of industry-leading tools such as Canva and Figma to craft user-centric designs that engage and delight. With a keen eye for aesthetics and functionality, we create intuitive interfaces that seamlessly guide users through your digital landscape. Whether it's crafting pixel-perfect visuals or designing fluid user journeys, our expertise ensures a harmonious blend of creativity and usability. Elevate your project with our UI/UX Design services and let us help you make a lasting impact in the digital realm.",
  },
  // {
  //   id: 4,
  //   icon:
  //     "https://images.unsplash.com/photo-1610824352934-c10d87b700cc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mjl8fHByb2R1Y3RzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  //   name: "Water Bottle",
  //   price: "$14.99",
  //   description: "Some text about the product..",
  // },
  // {
  //   id: 5,
  //   icon:
  //     "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzB8fHByb2R1Y3RzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  //   name: "Vans sneakers",
  //   price: "$38.99",
  //   description: "Some text about the product..",
  // },
  // {
  //   id: 6,
  //   icon:
  //     "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzV8fHByb2R1Y3RzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  //   name: "Coco Noir",
  //   price: "$149.99",
  //   description: "Some text about the product..",
  // },
  // {
  //   id: 7,
  //   icon:
  //     "https://images.unsplash.com/photo-1589782182703-2aaa69037b5b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OTJ8fHByb2R1Y3RzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  //   name: "Sunglasses",
  //   price: "$38.99",
  //   description: "Some text about the product..",
  // },
  // {
  //   id: 8,
  //   icon:
  //     "https://images.unsplash.com/photo-1625772452859-1c03d5bf1137?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fHByb2R1Y3RzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  //   name: "Dove cream",
  //   price: "$49.99",
  //   description: "Some text about the product..",
  // },
];
